export default {
  name: 'framesAnimation',
  props: {
    // 通用地址 require 上下文函数，图片数量多推荐使用 lazy-once 模式，所有图合为一个chunk
    // https://webpack.docschina.org/api/module-methods/#magic-comments
    // 拼接为 `prefixUrl (${index})`，index 从 1 开始。这个格式可以全选图片，选第一个图，按 F2，输入img，再回车，修改文件名的出来 ps: 记得保留副本再修改
    urlContextFn: {
      type: Function,
      default: () => {}
    },
    // 序列帧时间长度
    duration: {
      type: Number,
      default: 0
    },
    // 序列帧总数
    amount: {
      type: Number,
      default: 0
    },
    imgType: {
      type: String,
      default: 'jpg'
    },
    canWebp: {
      type: Boolean,
      default: false
    }
  },
  data() {
    const intervalMs = this.duration / (this.amount - 1);
    return {
      list: [],
      index: 1,
      intervalMs,
      loaded: false,
      loadedCount: 0,
      stopped: false
    };
  },
  mounted() {
    this.canvas = this.$refs.canvas;
    this.canvasContext = this.canvas.getContext('2d');
  },
  methods: {
    load() {
      if (this.loaded) return false;
      this.loaded = true;
      let imgType = this.imgType;
      if (this.canWebp) {
        const supportWebP = (function() {
          var canvas = typeof document === 'object' ? document.createElement('canvas') : {};
          canvas.width = canvas.height = 1;
          return canvas.toDataURL ? canvas.toDataURL('image/webp').indexOf('image/webp') === 5 : false;
        })();
        if (supportWebP) {
          imgType = 'webp';
        }
      }
      if (this.urlContextFn.name === 'webpackContext') {
        for (let i = 1; i <= this.amount; i++) {
          let img = new Image();
          // 	require 传值如果是表达式，看 https://webpack.docschina.org/guides/dependency-management/#require-with-expression
          // 会将唯一确定的目录下匹配的文件都加载上
          // 1. 如 require(`../${url}/${name}.${type}`) 会将 coloros11/src 下面的所有文件都加载上，导致打包异常。
          // 2. 如 const url = `../${url}/${name}.${type}`;require(url)，这个时候解析的type类型可能错乱
          // 为了通用性，采用 require.context 传入的方式
          img.src = this.urlContextFn(`./img (${i}).${imgType}`);
          img.onload = () => {
            this.loadedCount++;
          };
          this.list.push(img);
        }
      } else {
        // 说明是 webpackAsyncContext，其会返回一个promise
        for (let i = 1; i <= this.amount; i++) {
          // 采用promise的形式
          this.urlContextFn(`./img (${i}).${imgType}`).then(src => {
            let img = new Image();
            img.src = src;
            img.onload = () => {
              this.loadedCount++;
            };
            this.list.push(img);
          });
        }
      }
    },
    play() {
      const canvas = this.$refs.canvas;
      this.stopped = false;
      if (this.playTimer) clearInterval(this.playTimer);
      if (!canvas) {
        this.playTimer = setTimeout(() => {
          if (!this.stopped) this.play();
        }, 50);
        return;
      }
      if (this.index > 1) this.index = 1;

      const drawFrame = (index, go) => {
        this.drawFrame(index);
        if (go && !this.stopped && ++this.index <= this.amount) {
          if (this.drawTimer) clearInterval(this.drawTimer);
          this.drawTimer = setTimeout(() => {
            drawFrame(this.index, true);
          }, this.intervalMs);
        }
      };

      if (this.loadedCount < this.amount / 3) {
        // 加载的数量过少，过50ms后重新绘制
        drawFrame(1);
        this.playTimer = setTimeout(() => {
          if (!this.stopped) this.play();
        }, 50);
      } else {
        drawFrame(this.index, true);
      }
    },
    // 单个绘制
    drawFrame(index) {
      const img = this.list[index - 1];
      if (!img) return;
      this.canvas.width = img.width;
      this.canvas.height = img.height;

      this.canvasContext.clearRect(0, 0, img.width, img.height);
      this.canvasContext.drawImage(img, 0, 0, img.width, img.height, 0, 0, img.width, img.height);
    },
    stop() {
      this.stopped = true;
    }
  },
  render() {
    return <canvas ref="canvas"></canvas>;
  }
};
